import { ElementType } from 'react';

import i18next from 'i18next';

import { SOCIAL } from 'translations';

import EmailIcon from '../../components/icons/EmailIcon';
import FacebookIcon from '../../components/icons/FacebookIcon';
import LinkedInIcon from '../../components/icons/LinkedInIcon';
import TwitterIcon from '../../components/icons/TwitterIcon';
import { getDomain } from '../../helpers/root';

export enum SocialMediaNames {
  FACEBOOK = 'Facebook',
  TWITTER = 'Twitter',
  LINKEDIN = 'LinkedIn',
  EMAIL = 'Email',
}

const emailUrl = (url: string): string => {
  const subject: string = i18next.t(SOCIAL.SHARE_BY_EMAIL_SUBJECT);
  const body: string = i18next.t(SOCIAL.SHARE_BY_EMAIL_BODY, { link: url });
  return `mailto:?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
};

export const getSocialMediaDefinitions = (
  socialMediaNames: SocialMediaNames[],
  title: string,
  locationPathName: string
): SocialMediaDefinition[] => {
  const windowLocation = getDomain() + locationPathName;
  const encodedUrl = encodeURIComponent(windowLocation);
  const encodedTitle = encodeURIComponent(title);

  return socialMediaNames
    .map((socialMediaName) => {
      switch (socialMediaName) {
        case SocialMediaNames.EMAIL:
          return {
            key: SocialMediaNames.EMAIL,
            icon: EmailIcon,
            title: i18next.t(SOCIAL.SHARE_BY_EMAIL),
            url: emailUrl(getDomain() + locationPathName),
          };
        case SocialMediaNames.FACEBOOK:
          return {
            key: SocialMediaNames.FACEBOOK,
            icon: FacebookIcon,
            title: i18next.t(SOCIAL.SN_SHARE_ON, {
              sn: SocialMediaNames.FACEBOOK,
            }),
            url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&amp;src=sdkpreparse&amp;display=popup&amp;ref=plugin&amp;src=share_button&amp;sdk=joey`,
          };

        case SocialMediaNames.TWITTER:
          return {
            key: SocialMediaNames.TWITTER,
            icon: TwitterIcon,
            title: i18next.t(SOCIAL.SN_SHARE_ON, {
              sn: SocialMediaNames.TWITTER,
            }),
            url: `https://twitter.com/intent/tweet?${[
              encodedUrl && `url=${encodedUrl}`,
              encodedTitle && `text=${encodedTitle}`,
              'via=GroupeLaPoste',
            ]
              .filter(Boolean)
              .join('&')}`,
          };
        case SocialMediaNames.LINKEDIN:
          return {
            key: SocialMediaNames.LINKEDIN,
            icon: LinkedInIcon,
            title: i18next.t(SOCIAL.SN_SHARE_ON, {
              sn: SocialMediaNames.LINKEDIN,
            }),
            url: `https://www.linkedin.com/shareArticle?${[
              'mini=true',
              encodedUrl && `url=${encodedUrl}`,
              'source=Le%20Groupe%20La%20Poste',
            ]
              .filter(Boolean)
              .join('&')}`,
          };
        default:
          return undefined;
      }
    })
    .filter(Boolean);
};

export type SocialMediaDefinition = {
  key: SocialMediaNames;
  icon: ElementType;
  title: string;
  url: string;
};
